<template>
    <div id="deduplicate">
        <div class="indigo deduplicatesEmails" height="30px" id="deduplicate__header">
            <div id="deduplicate__header--1" @click.prevent="sortBy('ID')"><b class="bold_font">ID</b></div>
            <div id="deduplicate__header--2" ><b class="bold_font">Subject</b></div>
            <div id="deduplicate__header--3" ><b class="bold_font">Sender</b></div>
            <div id="deduplicate__header--4" @click.prevent="sortBy('original_date')" ><b>Original Sent Date</b></div>
            <div id="deduplicate__header--5" ><b>Total Duplicates</b></div>
        </div>
        <div v-if="isloading" class="loader"></div>
        <v-card v-else-if="deduplicates.length > 0">
            <v-list id="deduplicate__list">
                <v-list-item-group>
                    <DeduplicateItem
                      v-for="(dedup,i) in deduplicates"
                      v-bind:key="dedup.original_muid"
                      v-bind:dedup="dedup"
                      @showDuplicates="showDuplicates"
                      :class="dedupClass(i)"/>
                </v-list-item-group>
            </v-list>
        </v-card>
        <div v-else>No Records</div>
        <v-card v-if="show_duplicate">
          <DeduplicateCheck @showDuplicates="showDuplicates" @hidePopup="hidePopup" :dedupObject="dedupObject" />
        </v-card>
    </div>
</template>
<script>
    import _ from 'lodash'
    import DeduplicateItem from './../components/DeduplicateItem'
    import DeduplicateCheck from './../components/DeduplicateCheck'
    export default {
        name: 'Deduplicate',
        data() {
            return {
                orders: [
                    {'key': 'ID', 'val': true},
                    {'key': 'original_date', 'val': true}
                ],
                enableSorting: false,
                show_duplicate: false,
                dedupObject: false
            }
        },
        components: {
            DeduplicateItem,
            DeduplicateCheck
        },
        mounted() {
            this.$utils.fetchDeduplicates(this)
        },
        computed: {
            deduplicates: function () {
                return this.allDeduplicates()
            },
            isloading: function () {
                return this.$store.getters['Deduplicate/getIsLoading']
            },
        },
        methods: {
            getPages: function () {
                var arr = new Array(),
                    start = parseInt(1),
                    end = parseInt(this.lastPage), i;
                if (parseInt(this.totPage) > parseInt(10)) {
                    if (parseInt(this.currentPage) <= 4) {
                        end = 9
                    } else if (parseInt(this.currentPage) == parseInt(this.lastPage)) {
                        start = parseInt(this.lastPage / 10) * 10 + 1
                        end = this.lastPage
                    } else if (parseInt(this.currentPage) >= parseInt(5)) {
                        start = this.currentPage - 4
                        if (parseInt(this.lastPage) - parseInt(this.currentPage) <= 4) {
                            end = this.lastPage
                        } else {
                            end = this.currentPage + 4
                        }
                    }
                }
                for (i = start; i <= end; i++) {
                    arr.push(i)
                }
                return arr
            },
            sortBy: function (sortby) {
                this.enableSorting = true
                const order = _.find(this.orders, function (o) {
                    return o.key === sortby;
                });
                var view = this,
                    payload = this.$store.getters['Deduplicate/getResponsePayload'],
                    sorted = _.sortBy(payload, [function (o) {
                        return order.key === 'ID' ? parseInt(o[order.key]) : o[order.key];
                    }]);
                view.$store.dispatch('Deduplicate/setResponsePayload', order.val ? sorted : sorted.reverse()).then(function () {
                    view.orders.forEach(function (o) {
                        if (o.key === order.key) {
                            o.val = !o.val;
                        }
                    });
                }).catch(function (e) {
                    console.log(e)
                })
            },
            allDeduplicates: function() {
                if (this.enableSorting) {
                    this.enableSorting = false
                    return this.$store.getters['Deduplicate/getResponsePayload']
                } else {
                    return this.$store.getters['Deduplicate/getResponsePayload']
                }
            },
            dedupClass: function(i) {
                return parseInt(i)%2 === parseInt(0) ? 'grey lighten-2' : 'grey lighten-5'
            },
            showDuplicates: function(dedupObject){
              this.dedupObject = dedupObject
              this.show_duplicate = !this.show_duplicate
            },
            hidePopup: function(flag){
              if(flag){
                this.show_duplicate = false
              }
            }
        }
    }
</script>

<style lang="sass" scoped>
    @import "./../assets/sass/dedups.sass"
</style>
